import { deleteBiddingIntradayOrders } from '@ebalance/proto/bffuser/v1/bidding_intraday_service-BiddingIntradayService_connectquery'

import { biddingQueryKeys } from '~/hooks/bidding/queryKeys'
import { useWorkflowCaseScopedMutation } from '~/hooks/bidding/useWorkflowCaseScopedMutation'
import {
  type InvalidatingMutationResultFor,
  useInvalidatingMutation,
} from '~/hooks/useInvalidatingMutation'

/**
 * 時間前入札の下書きの一括削除 (入札を全削除 AC-BIN-138) mutation。 札ごとの結果は応答に載るので、
 * 一部の札を削除しなかった場合も成功として返り、 一覧は 1 件の削除 (`useDeleteBiddingIntradayOrder`)
 * と同じく読み直す。
 */
export function useDeleteBiddingIntradayOrders(): InvalidatingMutationResultFor<
  typeof deleteBiddingIntradayOrders
> {
  return useWorkflowCaseScopedMutation(
    useInvalidatingMutation(deleteBiddingIntradayOrders, [
      biddingQueryKeys.intradayList,
      biddingQueryKeys.intradayDetail,
    ]),
  )
}
